export default function getExtraFooter(prefixCls, mode, renderExtraFooter) {
    if (!renderExtraFooter) {
        return null;
    }
    return <div class={`${prefixCls}-footer-extra`}>{renderExtraFooter(mode)}</div>;
}
